import { render, staticRenderFns } from "./notification-settings.vue?vue&type=template&id=d447f3c2&scoped=true"
import script from "./notification-settings.vue?vue&type=script&lang=js"
export * from "./notification-settings.vue?vue&type=script&lang=js"
import style0 from "./notification-settings.vue?vue&type=style&index=0&id=d447f3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d447f3c2",
  null
  
)

export default component.exports